import { FormMixin } from "../../../../../core/mixins/form/FormMixin";

export const AuthMixin = {
  props: {
    configData: {
      type: Object,
    },
  },
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
    };
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    afterError(res) {
      this.preloader = false;
      let message = 'Something went wrong';
      if (res && res.data && res.data.message) {
        message = res.data.message;
      } else if (res && res.statusText) {
        message = res.statusText;
      }
      this.$toastr.e(message);
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterJsValidationFail() {
      this.preloader = false;
    },
  },
};
